"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var factory = function factory(_ref) {
  var identifier = _ref.identifier,
      FullscreenCtaButton = _ref.FullscreenCtaButton,
      CloseButton = _ref.CloseButton,
      PlyrWrapper = _ref.PlyrWrapper;

  var MobilePlayer = /*#__PURE__*/function (_Component) {
    _inherits(MobilePlayer, _Component);

    var _super = _createSuper(MobilePlayer);

    function MobilePlayer() {
      var _this;

      _classCallCheck(this, MobilePlayer);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "uniqueClassName", (0, _uniqueId["default"])('webinar-'));

      _defineProperty(_assertThisInitialized(_this), "renderStyle", function () {
        return /*#__PURE__*/_react["default"].createElement("style", {
          type: "text/css"
        }, ".".concat(_this.uniqueClassName, " .react-player {\n                    padding-bottom: ").concat(_this.props.ratio, "% !important;\n                    position: relative;\n                }\n                .").concat(_this.uniqueClassName, " .react-player > div {\n                    position: absolute;\n                    top: 0;\n                    left: 0;\n                    right: 0;\n                    bottom: 0;\n                }"));
      });

      return _this;
    }

    _createClass(MobilePlayer, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            children = _this$props.children,
            onCtaClick = _this$props.onCtaClick,
            onCloseClick = _this$props.onCloseClick,
            buttonProps = _this$props.buttonProps,
            playing = _this$props.playing,
            ctaVisible = _this$props.ctaVisible;
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, this.renderStyle(), /*#__PURE__*/_react["default"].createElement("div", {
          className: this.mobilePlayerClass
        }, /*#__PURE__*/_react["default"].createElement(PlyrWrapper, {
          className: this.uniqueClassName
        }, children), playing && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(CloseButton, {
          onCloseClick: onCloseClick
        }), /*#__PURE__*/_react["default"].createElement(FullscreenCtaButton, {
          onCtaClick: onCtaClick,
          buttonProps: buttonProps,
          ctaVisible: ctaVisible
        }))));
      }
    }, {
      key: "mobilePlayerClass",
      get: function get() {
        var _this$props2 = this.props,
            theme = _this$props2.theme,
            playing = _this$props2.playing;
        return (0, _classnames["default"])(theme.mobilePlayer, _defineProperty({}, theme.active, playing));
      }
    }]);

    return MobilePlayer;
  }(_react.Component);

  MobilePlayer.displayName = identifier;
  MobilePlayer.propTypes = {
    theme: _propTypes["default"].object.isRequired,
    children: _propTypes["default"].any.isRequired,
    ratio: _propTypes["default"].number.isRequired,
    buttonProps: _propTypes["default"].object.isRequired,
    playing: _propTypes["default"].bool.isRequired,
    ctaVisible: _propTypes["default"].bool.isRequired,
    onCloseClick: _propTypes["default"].func.isRequired,
    onCtaClick: _propTypes["default"].func.isRequired
  };
  return MobilePlayer;
};

var _default = factory;
exports["default"] = _default;